import { useRouter } from 'next/router';
import { useEffect } from 'react';

import useReturnPathStore from 'layout/Listing/store/useReturnPathStore';

const useSaveReturnPath = (key: string) => {
  const router = useRouter();
  const setPath = useReturnPathStore(state => state.setPath);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const fullPath = window.location.pathname + window.location.search;
    setPath(key, fullPath);
  }, [router.pathname, router.query, key]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
};

export default useSaveReturnPath;
